import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../notifications/useNotification';
import './Navbar.css'

const Navbar = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const { showError } = useNotification();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const handleNavigation = (page) => {
        switch (page) {
            case "contacts":
                navigate("/contacts");
                break;
            case "register":
                navigate("/register");
                break;
            case "login":
                navigate("/login");
                break;
            case "/":
                navigate("/");
                break;
            default:
                showError(t('unknown-error'));
        }
    }

    return (
        <div id='navbar-wrapper'>
            <nav id='navbar'>
                <div id='logo-name-wrapper'>
                    <img id='logo' src="/images/logo.svg" alt='logo' onClick={() => handleNavigation("/")} className='navbar-element'></img>
                    <p className='navbar-element app-name-text' onClick={() => handleNavigation("/")}>DietistPro</p>
                </div>
                <div id='central-links-wrapper'>
                    <p className='navbar-text-element'>{t("Our Service")}</p>
                    <p className='navbar-text-element'>{t("Pricing")}</p>
                    <p className='navbar-text-element' onClick={() => handleNavigation("contacts")}>{t("Contacts")}</p>
                </div>
                <div id='right-links-wrapper'>
                    <p className='navbar-text-element language-choice' onClick={() => changeLanguage('it')}>IT</p>
                    <p className='navbar-text-element language-choice' onClick={() => changeLanguage('en')}>EN</p>
                    <p id='navbar-login' className='navbar-text-element' onClick={() => handleNavigation("login")}>{t("Login")}</p>
                    <p id='navbar-register' className='navbar-text-element' onClick={() => handleNavigation("register")}>{t("Register")}</p>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;
